export default "__VITE_ASSET__KL9xnzNK__"